// Iter 634 — Owner/Admin: daftar pekerjaan operator yang pcs/titiknya belum lengkap + tombol Lengkapi Data.
import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { createPortal } from "react-dom";
import { TitikInputSheet } from "./bordir_titik_form";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (s) => s ? new Date(s).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";

export function IncompleteSheet({ operatorId, filters, onClose, tid = "incomplete-sheet" }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [edit, setEdit] = useState(null);
  const load = useCallback(() => {
    axios.get(`${API}/bordir-tasks/performance/incomplete`, { params: { operator_id: operatorId, ...filters }, withCredentials: true })
      .then(r => setData(r.data)).catch(e => setErr(e?.response?.data?.detail || e.message));
  }, [operatorId, filters]);
  useEffect(() => { load(); }, [load]);
  return createPortal(<div className="leaderboard-bordir opb-sheet" role="dialog" aria-modal="true" data-testid={tid}>
    <div className="opb-sheet-head">
      <b>Data Belum Lengkap{data ? ` · ${data.operator_name}` : ""}</b>
      <button type="button" className="soft-btn small-btn" onClick={onClose} data-testid={`${tid}-close`}>Tutup</button>
    </div>
    <div className="opb-sheet-body opb">
      {!data && !err && <div className="lb-row-sub">Memuat…</div>}
      {err && <div className="warn-box small" data-testid={`${tid}-error`}>{err}</div>}
      {data && data.items.length === 0 && <div className="lb-row-sub" data-testid={`${tid}-empty`}>Semua pekerjaan pada periode ini sudah lengkap.</div>}
      {data && data.items.map((x, i) => <div key={`${x.ref_id}-${i}`} className="opb-card" style={{ padding: 10 }} data-testid={`${tid}-row-${i}`}>
        <div style={{ fontWeight: 600 }} data-testid={`${tid}-row-${i}-order`}>{x.order_number || "—"}</div>
        <div className="lb-row-sub">{data.operator_name} · {fmt(x.at)} · {x.marketplace}</div>
        <div className="lb-row-sub" data-testid={`${tid}-row-${i}-status`}>{x.pcs === null ? "Pcs belum tercatat" : `${x.pcs} pcs · titik tercatat ${x.titik_pcs} pcs${x.pcs - (x.titik_pcs || 0) > 0 ? ` · ${x.pcs - (x.titik_pcs || 0)} pcs belum bertitik` : ""}${x.points !== null && x.points !== undefined ? ` · ${x.points} satuan titik terverifikasi` : ""}`}{x.reason ? ` — ${x.reason}` : ""}</div>
        {x.editable ? <button type="button" className="primary small-btn" style={{ marginTop: 6 }} onClick={() => setEdit(x)} data-testid={`${tid}-row-${i}-fix`}>Lengkapi Data</button>
          : <div className="lb-row-sub" data-testid={`${tid}-row-${i}-locked`}>Tidak dapat dilengkapi di sini (pesanan dikerjakan beberapa pekerjaan / titik posisi Offline).</div>}
      </div>)}
    </div>
    {edit && <TitikInputSheet kind={edit.kind} refId={edit.ref_id} onClose={() => setEdit(null)} onSaved={load} tid={`${tid}-form`}/>}
  </div>, document.body);
}

export default IncompleteSheet;
